import { QUERY_PARAMS } from '@constants/query-params.const';

export const RESET_PASSWORD_REQUIRED_PARAMS = [QUERY_PARAMS.RESET_PASSWORD_TOKEN];
